// App.js
// import 'antd/dist/antd.css';
import Cookies from "universal-cookie";

import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Login from './screens/Login';
import Dashboard from './screens/Dashboard';

import MonitoringOrder from './screens/monitoring/MonitoringOrder';
import MonitoringProgressive from "./screens/monitoring/MonitoringProgressive";
import MonitoringDocument from "./screens/monitoring/MonitoringDocument";

import UploadNotice from './screens/document/notice/UploadNotice';
import UploadNoticeWithInvoice from "./screens/document/notice/UploadNoticeWithInvoice";
import UploadAnalizeMultipleNotice from './screens/document/notice/UploadAnalizeMultipleNotice';
import LogAnalizedNoticeViewer from './screens/document/notice/LogAnalizedNoticeViewer';

import UploadStnk from './screens/document/UploadStnk';
import UploadBpkb from './screens/document/UploadBpkb';
import UpdateDocumentsNumber from './screens/document/DocumentsUpdateNumber';

import UploadInvoiceNotice from './screens/payment/UploadInvoiceNotice';
import UploadInvoiceServiceCost from './screens/payment/UploadInvoiceServiceCost';

import PaymentNotice from './screens/payment/PaymentNotice';
import PaymentProcessCost from './screens/payment/PaymentProcessCost';
import PaymentPkb from './screens/payment/PaymentPkb';
import UpdateStatusBill from './screens/payment/UpdateStatusBill';

import RetryPaymentNotice from './screens/internal/RetryPaymentNotice';
import NewRetryPaymentNotice from './screens/internal/NewRetryPaymentNotice';

import NotFoundPage from './screens/NotFoundPage';


// OLD MENU
// import ListOrder from './screens/ListOrder';
// import DocumentsUploadBpkbRetry from './screens/DocumentsUploadBpkbRetry';
// import ServiceBureauPaymentInvoice from './screens/ServiceBureauPaymentInvoice';
// import ServiceBureauInvoiceRepayment from './screens/ServiceBureauRepaymentInvoice';



const App = () => {

  useEffect(() => {
    const bc = new BroadcastChannel("logout_channel");

    bc.onmessage = (event) => {
      if (event.data === "logout") {
        // Hapus semua cookies
        const cookies = new Cookies();
        cookies.remove("_bbn_tn");
        cookies.remove("_bbn_un");
        cookies.remove("_bbn_ls");
        cookies.remove("_bbn_df");
        cookies.remove("_bbn_m");

        // Redirect
        window.location.href = "/login";
      }
    };

    return () => {
      bc.close();
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" caseSensitive={false} element={<Login />} />
        <Route path="/login" caseSensitive={false} element={<Login />} />

        <Route path="/:code_svb/dashboard" caseSensitive={false} element={<Dashboard />} />

        <Route path="/:code_svb/monitoring/order" caseSensitive={false} element={<MonitoringOrder />} />
        <Route path="/:code_svb/monitoring/progresif" caseSensitive={false} element={<MonitoringProgressive />} />
        <Route path="/:code_svb/monitoring/dokumen" caseSensitive={false} element={<MonitoringDocument />} />

        <Route path="/:code_svb/dokumen/notice/upload" caseSensitive={false} element={<UploadNotice />} />
        <Route path="/:code_svb/dokumen/notice/upload/v2" caseSensitive={false} element={<UploadNoticeWithInvoice />} />
        <Route path="/:code_svb/dokumen/notice/multi-upload" caseSensitive={false} element={<UploadAnalizeMultipleNotice />} />
        <Route path="/:code_svb/dokumen/notice/multi-upload/log" caseSensitive={false} element={<LogAnalizedNoticeViewer />} />

        <Route path="/:code_svb/dokumen/stnk/upload" caseSensitive={false} element={<UploadStnk />} />
        <Route path="/:code_svb/dokumen/bpkb/upload" caseSensitive={false} element={<UploadBpkb />} />
        <Route path="/:code_svb/dokumen/update/nomor-dokumen" caseSensitive={false} element={<UpdateDocumentsNumber />} />

        <Route path="/:code_svb/upload-tagihan/notice" caseSensitive={false} element={<UploadInvoiceNotice />} />
        <Route path="/:code_svb/upload-tagihan/jasa" caseSensitive={false} element={<UploadInvoiceServiceCost />} />

        <Route path="/:code_svb/pembayaran/tagihan/notice" caseSensitive={false} element={<PaymentNotice />} />
        <Route path="/:code_svb/pembayaran/tagihan/process" caseSensitive={false} element={<PaymentProcessCost />} />
        <Route path="/:code_svb/pembayaran/tagihan/pkb" caseSensitive={false} element={<PaymentPkb />} />

        <Route path="/:code_svb/update/status-tagihan" caseSensitive={false} element={<UpdateStatusBill />} />

        <Route path="/:code_svb/internal/pembayaran-ulang/tagihan/notice" caseSensitive={false} element={<RetryPaymentNotice />} />
        <Route path="/:code_svb/internal/pembayaran-ulang/tagihan/notice-new" caseSensitive={false} element={<NewRetryPaymentNotice />} />

        <Route path="*" element={<NotFoundPage />} />


        {/* OLD MENU */}
        {/* <Route path="/:code_svb/order/list-order" caseSensitive={false} element={<ListOrder />} />
        <Route path="/:code_svb/document/upload/bpkb/retry" caseSensitive={false} element={<DocumentsUploadBpkbRetry />} /> */}

        {/* <Route path="/:code_svb/service-bureau/invoice-payment" caseSensitive={false} element={<ServiceBureauPaymentInvoice />} /> */}
        {/* <Route path="/:code_svb/service-bureau/invoice-repayment" caseSensitive={false} element={<ServiceBureauInvoiceRepayment />} /> */}





      </Routes>
    </Router>
  );
};

export default App;
